/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import LoadWallet from "../../components/modal/LoadWallet";
import { getApiCaller } from "../../libs/apiCaller";

const Wallet = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [profileInfo, setProfileInfo] = useState({});
  const [amount, setAmount] = useState(0);
  const [loadWalletModal, setLoadWalletModal] = useState(false);
  const [isLoadingLoadWallet, setIsLoadingLoadWallet] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const providerId = location.state?.providerId;

  useEffect(() => {
    if (location.pathname.includes("consumerProfile")) {
      getTransactionData();
      getProfileDetails("consumer_details?consumer_id");
    } else {
      getTransactionData();
      getProfileDetails("provider_details?provider_id");
    }
  }, [location.pathname]);

  const getTransactionData = async () => {
    setIsLoading(true);
    const endPoint = `transactions?user_id=${id}`;
    try {
      const response = await getApiCaller(endPoint);
      if (response?.data?.response_code === 200) {
        setTransactionData(response?.data?.response_data);
      }
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
    setIsLoading(false);
  };

  const getProfileDetails = async (routePath) => {
    setIsLoading(true);
    const endPoint = `${routePath}=${id}`;
    try {
      const response = await getApiCaller(endPoint);
      if (response?.data?.response_code === 200) {
        if (routePath === "consumer_details?consumer_id") {
          const reposneData = response?.data?.response_data?.[0];
          setProfileInfo(reposneData?.profile_info);
        } else {
          setProfileInfo(response?.data?.response_data);
        }
      }
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
    setIsLoading(false);
  };

  const handleMakePayment = async (amount) => {
    try {
      setIsLoadingLoadWallet(true);
      const endPoint = `admin_add_balance_user?user_id=${
        profileInfo?.id
      }&amount=${String(amount)}&type=${
        selectedIndex === 0 ? "increase" : "decrease"
      }`;
      const response = await getApiCaller(endPoint);
      if (response?.data.response_code === 200) {
        toast.success(response.data.response_message);
        setLoadWalletModal(false);
        getTransactionData();
        getProfileDetails(
          location.pathname.includes("consumerProfile")
            ? "consumer_details?consumer_id"
            : "provider_details?provider_id"
        );
      } else {
        toast.error(response?.data?.response_message);
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.message);
    } finally {
      setIsLoadingLoadWallet(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="text-center flex items-center justify-center my-10 h-[70vh]">
          <PropagateLoader color="#284184" loading={true} size={10} />
        </div>
      )}
      {!isLoading && (
        <div className="min-h-screen bg-gray-50">
          {/* Header Navigation */}
          <div className="flex px-4 md:px-10 mt-6 text-sm ">
            <a
              href={
                location.pathname.includes("consumerProfile")
                  ? "/consumer"
                  : "/provider"
              }
              className="text-[#284184] text-xl hover:underline"
            >
              All{" "}
              {location.pathname.includes("consumerProfile")
                ? "Consumers"
                : "Providers"}
            </a>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <button
              className="text-[#284184] text-xl font-[Lato-Regular] hover:underline"
              onClick={() => {
                if (location.pathname.includes("consumerProfile")) {
                  navigate(`/consumerProfile/${id}`);
                } else {
                  navigate("/providerProfile", {
                    state: { provider: { id: providerId } },
                  });
                }
              }}
            >
              {profileInfo?.first_name} {profileInfo?.last_name}
            </button>
            <span className="text-[#284184]">
              <FiChevronRight className="text-2xl" />
            </span>
            <span className="text-[#284184] text-xl font-bold">Wallet</span>
          </div>

          {/* Balance Card */}
          <div className="px-4 md:px-10 mt-4">
            <div className="flex justify-center bg-white rounded-lg shadow-sm p-6 mb-6">
              <div className="">
                <p className="text-4xl font-semibold text-[#284184]">
                  $
                  {location.pathname.includes("consumerProfile")
                    ? profileInfo?.wallet_balance || 0
                    : profileInfo?.wallet_amount || 0}
                </p>
                <button
                  className="text-blue-600 text-sm mt-2 underline"
                  onClick={() => setLoadWalletModal(true)}
                  disabled={isLoadingLoadWallet}
                >
                  Load Wallet
                </button>
              </div>
            </div>

            {/* Transactions */}
            <div className="bg-white rounded-lg shadow-sm">
              <div className="p-4 border-b">
                <h2 className="text-xl font-bold text-[#284184]">
                  Transactions
                </h2>
              </div>
              <div className="divide-y">
                {transactionData &&
                  transactionData?.map((transaction) => (
                    <div
                      key={transaction.id}
                      className="py-3 flex items-center justify-between"
                    >
                      <div className="px-4">
                        <p className="text-gray-800">
                          {transaction.title === "Appointment Schedule Fees"
                            ? transaction?.patient_name
                            : transaction.title}
                        </p>
                        {transaction.title === "Appointment Schedule Fees" && (
                          <p className="text-sm text-gray-500">
                            {moment(transaction?.date, "DD-MM-YYYY").format(
                              "DD MMM, ddd"
                            )}
                            {transaction.time && `, ${transaction.time}`}
                          </p>
                        )}
                      </div>
                      <p
                        className={`text-right font-semibold px-4 ${
                          transaction.is_credit
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      >
                        {transaction.is_credit ? "+" : "-"}$
                        {Math.abs(transaction.amount)}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <LoadWallet
        setAmount={setAmount}
        amount={amount}
        handleMakePayment={handleMakePayment}
        isOpen={loadWalletModal}
        onClose={() => {
          setLoadWalletModal(false);
          setSelectedIndex(0);
        }}
        isLoadingLoadWallet={isLoadingLoadWallet}
        setSelectedIndex={setSelectedIndex}
        selectedIndex={selectedIndex}
      />
    </>
  );
};

export default Wallet;
